import ControldocDataTable from './datatable';

export default ControldocDataTable;
